import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import s from '../Sidebar/Sidebar.module.scss'; // Reusing Sidebar styles
import classNames from 'classnames';
import collapseIcon from '../../assets/collapse.svg'; // Reuse existing icons
import expandIcon from '../../assets/expand.svg';
import trashIcon from '../../assets/trash-can-grey.svg';
import PinIcon from './PinIcon';

const DynamicNavigation = ({ links, onRemoveLink, sidebarOpen, handleViewSidebar }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const location = useLocation();

    if (!links || links.length === 0) return null;

    return (
        <div className={s.dynamicNav}>
            {/* Separator or Header */}
            <div
                className={classNames(s.sidebarHeader, s.dynamicHeader)}
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ cursor: 'pointer', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <span style={{ fontSize: '12px', color: '#6c757d', fontWeight: 600, textTransform: 'uppercase' }}>
                    {sidebarOpen ? <FormattedMessage id="sidebar.myPins" defaultMessage="MY PINS" /> : '...'}
                </span>
                {sidebarOpen && (
                    <img
                        src={isExpanded ? collapseIcon : expandIcon}
                        alt="toggle"
                        width="12"
                    />
                )}
            </div>

            {(isExpanded || !sidebarOpen) && (
                <ul className="list-unstyled components">
                    {links.map((link, index) => (
                        <li className={location.pathname === link.path ? s.activeLink : ''} key={index}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px' }}>
                                <Link
                                    to={link.path}
                                    className="d-flex align-items-center flex-grow-1"
                                    style={{ textDecoration: 'none', color: 'inherit', padding: '10px 16px', overflow: 'hidden' }}
                                    onClick={
                                        window.innerWidth <= 768
                                            ? () => handleViewSidebar(true)
                                            : () => false
                                    }
                                    title={link.title}
                                >
                                    <div style={{
                                        transform: location.pathname === link.path ? 'rotate(0deg)' : 'rotate(45deg)',
                                        transition: 'transform 0.3s ease',
                                        display: 'flex',
                                        flexShrink: 0
                                    }}>
                                        <PinIcon
                                            fill="currentColor"
                                            width="16"
                                            height="16"
                                            className="me-2"
                                        />
                                    </div>
                                    {sidebarOpen && <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{link.title}</span>}
                                </Link>
                                {sidebarOpen && (
                                    <img
                                        src={trashIcon}
                                        alt="delete"
                                        width="14"
                                        style={{ cursor: 'pointer', marginLeft: '8px' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            onRemoveLink(link.path);
                                        }}
                                    />
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

DynamicNavigation.propTypes = {
    links: PropTypes.array.isRequired,
    onRemoveLink: PropTypes.func.isRequired,
    sidebarOpen: PropTypes.bool.isRequired,
    handleViewSidebar: PropTypes.func
};

export default DynamicNavigation;
